module.exports = __webpack_public_path__ + "img/Text_Logo_White.5ef1992a.svg";